export const TABLE_COLUMNS_NAMES = [
	{ dataIndex: 'id', title: '#', width: 100, align: 'center' },
	{ dataIndex: 'admin', title: 'Статус Админ' },
	{ dataIndex: 'zak', title: 'Статус ЗАК' },
	{ dataIndex: 'tk', title: 'Статус TK' },
];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
